module.exports = __webpack_public_path__ + "static/media/avenir-next-bold.078ada03.eot";